module.exports = __webpack_public_path__ + "img/shared-4.adc7e838.jpg";